module.exports = __webpack_public_path__ + "static/media/devinbenko.97b66181.png";